import { render } from "./AddEditBackground.vue?vue&type=template&id=60365e0e&scoped=true"
import script from "./AddEditBackground.vue?vue&type=script&lang=js"
export * from "./AddEditBackground.vue?vue&type=script&lang=js"

import "./AddEditBackground.vue?vue&type=style&index=0&id=60365e0e&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60365e0e"]])

export default __exports__